import { c as _c } from "react/compiler-runtime";
import { cn } from '../../../shared/cn';
import type { CodeProps } from './textProps';
export function Code(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("w-fit rounded-md border border-borderPrimary bg-backgroundSecondary px-1 py-0.5 font-medium font-sans text-contentPrimary text-sm hover:opacity-90 sm:text-[0.8125rem]", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <code {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}